import React from 'react'
import { ProgressBar, Step } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import styles from "./Stepper.module.css"
import BlueDotImage from "../../public/assets/BlueDot.svg"
import GrayDotImage from "../../public/assets/GrayDot.svg"
import { Col, Row } from 'react-bootstrap';
import { useMyContext } from '../../myContext';

function Stepper({ stepPercent }) {

  const {themeColor} = useMyContext();

  const ThemeColorDiv = () => {
    return(
      <>
      <div style={{height: "30px", width: "30px", borderRadius: "50%", background: themeColor, position: "relative"}}></div>
      <div style={{height: "9px", width: "9px", borderRadius: "50%", background: "white", position: "absolute"}}></div></>
    )
  }

  return (
    <div className={styles.outerdiv}>
      <ProgressBar
        percent={stepPercent}
        filledBackground="linear-gradient(to right, #fefb72, #f0bb31)"
      >
        <Step transition="scale">
          {({ accomplished }) => (
            <>
              {/* <img
                alt=""
                style={{ filter: `grayscale(${accomplished ? 0 : 80}%)`, position: "relative" }}
                width="30"
                src={BlueDotImage}
              /> */}
              <ThemeColorDiv />
              <div className={styles.ProgressBarText}>
              <p className={styles.firstLine} style={ stepPercent >= 0 ? { color: themeColor } : { color: "black"}}>Purpose Selection</p>
              <p className={styles.secondLine}>Choose the appropriate reason</p>
            </div>
            </>
          )}
        </Step>
        <Step transition="scale">
          {({ accomplished }) => (
            <>
            {stepPercent >= 50 ? <ThemeColorDiv /> : <img
                alt=""
                style={ stepPercent >= 50 ? { filter: `grayscale(${accomplished ? 0 : 80}%)` } : { filter: `grayscale(${accomplished ? 0 : 80}%)`, backgroundColor: "white" }}
                width="30"
                src={GrayDotImage}
              />}
              <div className={styles.ProgressBarText}>
              <p className={styles.firstLine} style={ stepPercent >= 50 ? { color: themeColor } : { color: "black"}}>Account Setup</p>
              <p className={styles.secondLine}>Remitter & Beneficiary details</p>
            </div>
            </>
          )}
        </Step>
        <Step transition="scale">
          {({ accomplished }) => (
            <>
            {stepPercent === 100 ? <ThemeColorDiv /> :  <img
                alt=""
                style={ stepPercent === 100 ? { filter: `grayscale(${accomplished ? 0 : 80}%)` } : { filter: `grayscale(${accomplished ? 0 : 80}%)`, backgroundColor: "white" }}
                width="30"
                src={GrayDotImage}
              />}
              <div className={styles.ProgressBarText}>
              <p className={styles.firstLine} style={ stepPercent === 100 ? { color: themeColor } : { color: "black"}}>Transfer Money</p>
              <p className={styles.secondLine}>Get quote on exchange rate & transfer</p>
            </div>
            </>
          )}
        </Step>
      </ProgressBar>

     </div>
  )
}

export default Stepper
